export default ({ data }, { market, t }) => {
  if (!data) {
    return {};
  }

  const { prismicArticle } = data;

  if (!prismicArticle) {
    return {};
  }

  const articleUrl = `${market.domain}/${prismicArticle.pathName}`;
  const articleTitle =
    prismicArticle.data.meta.title ?? prismicArticle.data.title[0].text;
  const articleDescription =
    prismicArticle.data.meta.description ??
    (prismicArticle.data.metaDescription?.length
      ? prismicArticle.data.metaDescription[0].text
      : null);

  const featuredImage = prismicArticle.data.featuredImage?.url;
  const articleImages = [featuredImage]
    .concat(
      prismicArticle.data.body.map(slice => {
        switch (slice.type) {
          case 'HERO_TITLE':
            return slice.primary?.image?.url;
          case 'IMAGE':
            return slice.primary?.image?.url;
          default:
            return null;
        }
      })
    )
    .filter(x => x);

  const openGraph = [
    { key: 'title', content: articleTitle },
    { key: 'type', content: 'article' },
    { key: 'url', content: articleUrl },
    { key: 'image', content: articleImages[0] },
  ];

  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    datePublished: prismicArticle.publishedAt,
    dateModified: prismicArticle.updatedAt,
    headline: articleTitle,
    image: articleImages[0],
    description: articleDescription,
  };

  return {
    title: t('meta', 'article.page-title', { title: articleTitle }),
    description: articleDescription,
    canonical: articleUrl,
    structuredData,
    openGraph,
    hrefLang: [],
  };
};
